module.exports = __webpack_public_path__ + "2acb60f2/img/splash-icon.07a7c465.svg";